import(/* webpackMode: "eager" */ "/codebuild/output/src2763183136/src/qbs-website-forntend/node_modules/next/font/google/target.css?{\"path\":\"src/app/layout.tsx\",\"import\":\"Inter\",\"arguments\":[{\"subsets\":[\"latin\"]}],\"variableName\":\"inter\"}");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src2763183136/src/qbs-website-forntend/src/components/common/Snackbar.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AuthProvider"] */ "/codebuild/output/src2763183136/src/qbs-website-forntend/src/context/AuthContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ThemeProvider"] */ "/codebuild/output/src2763183136/src/qbs-website-forntend/src/context/themeContext.tsx");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src2763183136/src/qbs-website-forntend/styles/globals.css");
